function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.5383 1.41194C10.7091 1.0013 11.2909 1.0013 11.4617 1.41194L13.7423 6.8953C13.9583 7.41466 14.4467 7.76951 15.0074 7.81446L20.9272 8.28905C21.3705 8.32459 21.5503 8.87784 21.2125 9.16717L16.7023 13.0307C16.2751 13.3966 16.0885 13.9708 16.219 14.5179L17.597 20.2946C17.7002 20.7272 17.2296 21.0691 16.85 20.8373L11.7819 17.7417C11.3019 17.4485 10.6981 17.4485 10.2181 17.7417L5.14999 20.8373C4.77044 21.0691 4.29981 20.7272 4.40301 20.2946L5.78095 14.5179C5.91146 13.9708 5.72491 13.3966 5.29772 13.0307L0.7875 9.16718C0.44973 8.87784 0.629495 8.32459 1.07282 8.28905L6.99257 7.81446C7.55326 7.76951 8.04167 7.41466 8.25768 6.89531L10.5383 1.41194Z",
    stroke: "#FFB800",
    style: {
      stroke: "#FFB800",
      stroke: "color(display-p3 1.0000 0.7200 0.0000)",
      strokeOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.17c9c5221a479051c377d07976400828.svg";
export { ForwardRef as ReactComponent };